import React from "react";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
import {convertIosStringToDate, formatDateToString} from "helper/common";
import {FORMAT_TIME} from "types/enums";
const columns: ColumnProps<any>[] = [
  {
    key: "2",
    title: "STT",
    dataIndex: "stt",
    align: "center",
    width: 120,
  },

  {
    key: "3",
    title: "Tên vật tư",
    dataIndex: "vtytIds",
    render(value, record, index) {
      return (
        <>
          {record?.bidVTYTDtos.map(e => (
            <div>
              {e?.id} - {e?.vtytName}
            </div>
          ))}
        </>
      );
    },
    align: "left",
    width: "20%",
  },
  {
    key: "name",
    title: "Tên đơn vị",
    dataIndex: "name",
    align: "left",
    width: 180,
  },

  {
    key: "3",
    title: "Số thầu",
    dataIndex: "bidCode",
    align: "left",
    width: "20%",
  },
  {
    key: "4",
    title: "Quyết định",
    dataIndex: "decision",
    align: "left",
  },
  {
    key: "5",
    title: "Ngày công bố",
    dataIndex: "announced",
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dayFull)}</>;
    },
    align: "left",
    width: "20%",
  },
  {
    key: "6",
    title: "Ghi chú",
    dataIndex: "note",
    align: "left",
  },

  {key: "7", title: "Thao tác", dataIndex: "action", width: 100},
];
export {columns};
